import Vue from 'vue';

let audio = new Audio('/static/audio/message_sound.mp3');

function playNotification() {
    audio.load();
    try {
        audio.play(); // ios no interaction error message possible.
    } catch (e) {
    }
}

export const onNewConversationMessageDefaultListener = async (e) => {
    /**
     * @param {LiveEventNewConversationMessage} e
     */
    const $rootScope = Vue.getAngularModule('$rootScope');
    let notification_scope = $rootScope.$new();
    notification_scope.msg = e;
    Vue.notifications.Notification({
        delay: 8000,
        title: 'New Message',
        templateUrl: 'ws.conversation.newMessage.html',
        scope: notification_scope
    });
    $rootScope.$broadcast('conversations_unread_count_increased', e.conversation_id);
    playNotification();
};
